import type { Locale } from '../Entities/Locale/Locale.entity';
import {
  googleRecaptchaSiteKeyDE,
  googleRecaptchaSiteKeyFR,
  googleRecaptchaSiteKeyUK,
} from '../Environment/Variables';

const googleRecaptchaKeys: Record<Locale, string> = {
  fr: googleRecaptchaSiteKeyFR,
  uk: googleRecaptchaSiteKeyUK,
  de: googleRecaptchaSiteKeyDE,
};

export const loadGoogleRecaptcha = (locale: Locale) => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://www.google.com/recaptcha/api.js?render=${googleRecaptchaKeys[locale]}`;

      script.onload = () => {
        resolve('Google ReCaptcha loaded successfully');
      };

      script.onerror = () => {
        reject('Error: Unable to load Google ReCaptcha script');
      };
      head.appendChild(script);
    } else {
      resolve('success');
    }
  });
};

export const getReCaptchaToken = (action: string, locale: Locale = 'uk') => {
  return new Promise(res => {
    const { grecaptcha }: any = window;
    if (grecaptcha) {
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(googleRecaptchaKeys[locale], { action });
          return res(token);
        } catch (_err) {
          return res('');
        }
      });
    } else {
      return res('');
    }
  });
};
